import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BusinessManagment,BusinessLookupDto, PackageDto, GetSpecBusinessResponse } from 'app/public/model/BusinessManagment';
import { Observable, share } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusinessManagmentService {

  constructor(private httpClient: HttpClient) { }
  getBusinessRoulettes(request: any): Observable<{ BusinessRoulettes: BusinessManagment[], TotalCount: number }> {
    return this.httpClient.post<{ BusinessRoulettes: BusinessManagment[], TotalCount: number }>('/manager', request).pipe(share());
  }

  getPackages(): Observable<PackageDto[]> {
    return this.httpClient.get<PackageDto[]>("/package");

  }
  getBusinessNames(): Observable<BusinessLookupDto[]> {
    return this.httpClient.get<BusinessLookupDto[]>('/businessNames');
  }
  getLeads(request:any):Observable<{ Lids: any[], TotalCount: number }>{
   return this.httpClient.post<{Lids: any[], TotalCount: number}>(`/leadsManagment`,request).pipe(share());
  }
  getLeadsSpecificBusiness(request:any):Observable<{ Lids: any[], TotalCount: number }>{
       return this.httpClient.post<{Lids: any[], TotalCount: number}>(`/leadsSpecificyBusiness`,request).pipe(share());
  }
  exportLeadsForManager(request) {
  return this.httpClient.post('/exportLeads', request, {
    responseType: 'blob',
    headers: { Accept: 'application/octet-stream' }
  });
}

exportBusinesses(request: any): Observable<Blob> {
    return this.httpClient.post('/exportBusinesses', request, { responseType: 'blob' });
  }

  getSpecificBusinessDetails(request: { BussinessId: number }) {
  return this.httpClient.post(`/atn/getConnectedBusinessInfo/${request.BussinessId}`, {})
    .pipe(share());
}
}
